import { useRef } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { RightPanelSnapshotRegistration } from '../contexts/RightPanelSnapshotRegistration'
import { useTurnAuthoritySnapshot } from '../contexts/TurnAuthoritySnapshotContext'
import { useTripChatMobileAppShell } from '../mobile/TripChatMobileAppShell'
import { useTripChatMobileOverlayOptional } from '../mobile/TripChatMobileOverlayContext'

interface Props {
  showTabs: boolean
}

export default function MobileSurfaceSnapshotRegistration({ showTabs }: Props) {
  const owner = useRef(Symbol('mobile overlay')).current
  const { activeTab } = useTripChatMobileAppShell()
  const overlay = useTripChatMobileOverlayOptional()
  const snapshot = useTurnAuthoritySnapshot()
  const topOverlay = overlay?.topOverlayId
  useIsomorphicLayoutEffect(() => {
    snapshot.current.mobileOverlayOwner = owner
    snapshot.current.mobileOverlay = topOverlay === 'drawer' ? undefined : topOverlay
    return () => {
      if (snapshot.current.mobileOverlayOwner !== owner) return
      snapshot.current.mobileOverlayOwner = undefined
      snapshot.current.mobileOverlay = undefined
    }
  }, [owner, snapshot, topOverlay])
  return <RightPanelSnapshotRegistration rightPanelView={showTabs ? activeTab : 'chat'} selectedMarkerData={undefined} />
}
